export default "__VITE_ASSET__Dc9N_vnx__"